import React, { useState, useEffect } from 'react';
import { IoArrowForward } from 'react-icons/io5';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/student/home/Cards.css';

const ModernCards = () => {
  const [activeCard, setActiveCard] = useState(0);
  const [displayText, setDisplayText] = useState('');
  const [textIndex, setTextIndex] = useState(0);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const cardsData = [
    {
      id: 1,
      tag: "UNIFORM SUPPORT",
      heading: "Empowering Futures Through Proper Attire",
      description: "We provide quality school uniforms for underprivileged students, ensuring every child attends school with dignity and confidence, removing barriers to education.",
      image: "https://static.vecteezy.com/system/resources/previews/023/128/999/non_2x/character-student-back-to-school-university-concept-illustration-vector.jpg",
      color: "#667eea",
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
      stats: { helped: "850+", amount: "PKR 3.5M+" }
    },
    {
      id: 2,
      tag: "BOOKS SUPPORT",
      heading: "Managing Books for Brighter Future",
      description: "We provide essential textbooks and learning materials to students, ensuring every child has access to quality education resources through our book donation programs.",
      image: "https://plus.unsplash.com/premium_photo-1669652639356-f5cb1a086976?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fGJvb2tzfGVufDB8fDB8fHww",
      color: "#f093fb",
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
      stats: { helped: "1200+", amount: "PKR 2.8M+" }
    },
    {
      id: 3,
      tag: "FEE SUPPORT",
      heading: "Empowering Through Educational Support",
      description: "We provide financial assistance for underprivileged students, ensuring every child attends school with dignity and confidence, removing barriers to education.",
      image: "https://img.freepik.com/premium-photo/donate-png-ripped-paper-word-sticker-typography-transparent-background_53876-952178.jpg",
      color: "#fa709a",
      gradient: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
      stats: { helped: "650+", amount: "PKR 5.2M+" }
    }
  ];

  const currentCard = cardsData[activeCard];

  const handleDonorLogin = () => {
    setLoading(true);
    setTimeout(() => {
      navigate("/donor/login");
    }, 800);
  };

  // Auto-rotation - har 5 seconds mein card change hoga
  useEffect(() => {
    const autoRotate = setInterval(() => {
      setActiveCard((prev) => (prev + 1) % cardsData.length);
    }, 5000); // 5 seconds

    return () => clearInterval(autoRotate);
  }, [cardsData.length]);

  // Typewriter effect
  useEffect(() => {
    setDisplayText('');
    setTextIndex(0);
  }, [activeCard]);

  useEffect(() => {
    if (textIndex < currentCard.heading.length) {
      const timeout = setTimeout(() => {
        setDisplayText(prev => prev + currentCard.heading[textIndex]);
        setTextIndex(textIndex + 1);
      }, 50);
      return () => clearTimeout(timeout);
    }
  }, [textIndex, currentCard.heading]);

  return (
    <section className="mc-split-cards-section">
      {/* Animated Background */}
      <div className="mc-animated-bg">
        <div className="mc-bg-gradient" style={{ background: currentCard.gradient }}></div>
        <div className="mc-bg-particles">
          {[...Array(20)].map((_, i) => (
            <div key={i} className="mc-particle" style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${5 + Math.random() * 10}s`
            }}></div>
          ))}
        </div>
      </div>

      <div className="mc-split-cards-container">

        {/* Left Side - Image Section */}
        <div className="mc-split-left-side">
          <div className="mc-image-showcase">
            {cardsData.map((card, index) => (
              <div
                key={card.id}
                className={`mc-showcase-image${index === activeCard ? ' active' : ''}`}
              >
                <div className="mc-image-wrapper">
                  <img src={card.image} alt={card.tag} />
                  <div className="mc-image-gradient" style={{ background: card.gradient }}></div>
                </div>

                {/* Decorative Elements */}
                <div className="mc-deco-circle mc-circle-1" style={{ borderColor: card.color }}></div>
                <div className="mc-deco-circle mc-circle-2" style={{ borderColor: card.color }}></div>
                <div className="mc-deco-line" style={{ background: card.gradient }}></div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side - Content Section */}
        <div className="mc-split-right-side">
          <div className="mc-content-area">

            {/* Section Tag */}
            <div className="mc-section-tag-wrapper">
              <span className="mc-pulse-dot" style={{ background: currentCard.color }}></span>
              <span className="mc-section-tag">OUR IMPACT AREAS</span>
            </div>

            {/* Card Tag */}
            <div className="mc-card-category" style={{ background: currentCard.gradient }}>
              <span className="mc-category-text">{currentCard.tag}</span>
            </div>

            {/* Heading with Typewriter */}
            <h2 className="mc-content-heading">
              {displayText}
              <span className="mc-cursor-blink">|</span>
            </h2>

            {/* Description */}
            <p className="mc-content-description">{currentCard.description}</p>

            {/* Stats */}
            <div className="mc-stats-row">
              <div className="mc-stat-box">
                <div className="mc-stat-icon">👥</div>
                <div className="mc-stat-info">
                  <div className="mc-stat-number" style={{ color: currentCard.color }}>
                    {currentCard.stats.helped}
                  </div>
                  <div className="mc-stat-label">Students Helped</div>
                </div>
              </div>
              <div className="mc-stat-divider"></div>
              <div className="mc-stat-box">
                <div className="mc-stat-icon">💵</div>
                <div className="mc-stat-info">
                  <div className="mc-stat-number" style={{ color: currentCard.color }}>
                    {currentCard.stats.amount}
                  </div>
                  <div className="mc-stat-label">Funds Raised</div>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <button
              className="mc-modern-cta-btn"
              style={{ background: currentCard.gradient }}
              onClick={handleDonorLogin}
              disabled={loading}
            >
              {loading ? (
                <span className="mc-btn-spinner" />
              ) : (
                <>
                  <span className="mc-btn-text">Make an Impact</span>
                  <span className="mc-btn-arrow">
                    <IoArrowForward />
                  </span>
                </>
              )}
              <div className="mc-btn-shine"></div>
            </button>

            {/* Dots Indicator */}
            <div className="mc-dots-container">
              {cardsData.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveCard(index)}
                  className={`mc-dot${index === activeCard ? ' active' : ''}`}
                  style={index === activeCard ? { background: currentCard.color } : {}}
                />
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default ModernCards;